import { render, staticRenderFns } from "./Totp.vue?vue&type=template&id=14c2d0d6&scoped=true&"
import script from "./Totp.vue?vue&type=script&lang=ts&"
export * from "./Totp.vue?vue&type=script&lang=ts&"
import style0 from "./Totp.vue?vue&type=style&index=0&id=14c2d0d6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14c2d0d6",
  null
  
)

export default component.exports